var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.87 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".quoracls-1{fill:#b72c27;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "quora") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "quoracls-1",
    d: "M68.34,105.81a54.73,54.73,0,0,1-14.06,1.87C26.86,107.7,0,85.81,0,54,0,21.87,26.86,0,54.28,0c27.87,0,54.43,21.74,54.43,54A52.29,52.29,0,0,1,88.19,96c3.75,5.89,8,9.81,13.62,9.81,6.15,0,8.62-4.76,9.06-8.49h8v2.88c-.59,7.43-5.12,22.72-24.4,22.72-13.57,0-20.75-7.87-26.13-17.09v0Zm-5.1-10C59,87.44,54,79,44.23,79A14.1,14.1,0,0,0,38.61,80L35.29,73.4c4-3.47,10.56-6.19,18.75-6.19,13,0,19.71,6.28,25,14.3,3.15-6.84,4.64-16.08,4.64-27.55,0-28.6-8.93-43.11-29.83-43.11C33.27,10.85,24.4,25.55,24.4,54s8.91,43,29.49,43a32,32,0,0,0,9-1.16l.39,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuora);
export default __webpack_public_path__ + "static/media/quora.644a947338297ccaac3ac3438866af92.svg";
export { ForwardRef as ReactComponent };